module.exports = __webpack_public_path__ + "img/login.3929c946.jpg";